import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import deepEqual from 'deep-equal'
import { connect } from 'react-redux'
import deepcopy from 'deepcopy'
import { DragSource, DropTarget } from 'react-dnd';
import { ItemTypes } from './Constants';
import { saveSetting } from '../actions/index';

import EditPanelManager from '../helpers/EditPanelManager';

const addonSource = {
  beginDrag(props){
    return {
      type: 'ADD_ADDON',
      name: props.addon.addon_name,
      addon: props.addon
    }
  },

  endDrag(props, monitor, component){
    let result = monitor.getDropResult();
    if(result && result.status){
      var newAddonId = (new Date).getTime();
      var addonName = props.addon.addon_name.replace(/sp_/g, '');

      let indexPosition = result.index;
      if(result.dropPosition == 'bottom'){
        indexPosition = result.index + 1;
      }

      let newAddon = {
        type: result.type,
        index: result.rowIndex,
        settings: {
          indexPosition: indexPosition,
          colIndex: result.colIndex,
          addonIndex: '',
          addonId: newAddonId,
          htmlContent: '',
          assets: '',
          addonName: addonName,
          formData: props.addon.default
        }
      };

      if(result.type == 'inner_addon'){
        newAddon.settings.innerRowIndex = result.innerRowIndex;
        newAddon.settings.innerColIndex = result.innerColIndex;
        newAddon.settings.addonIndex = result.innerRowIndex;
      }

      if(props.addon.js_template){

          props.onSettingsClick(newAddon);

          let addedAddonTmp = newAddon;
          

          if(result.type == 'inner_addon'){
            newAddon.settings.addonInnerIndex = indexPosition;
          } else {
            addedAddonTmp.settings.addonIndex = indexPosition;
          }
          
          EditPanelManager.setAddon(addedAddonTmp);
          EditPanelManager.setType(result.type);

          EditPanelManager.showEditPanel();
      } else {
        jQuery.ajax({
          type: 'POST',
          url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=setting_value',
          dataType: 'json',
          data: {
            id: newAddonId,
            name: addonName
          },
          cache: false,
          success: function(response) {
            newAddon.settings.htmlContent = response.html;
            newAddon.settings.assets = response.assets;
            newAddon.settings.formData = JSON.parse(response.formData);

            props.onSettingsClick(newAddon);

          }.bind(this)
        });

        props.onSettingsClick(newAddon);
        
        let addedAddon = newAddon;
        addedAddon.settings.addonIndex = indexPosition;
        
        EditPanelManager.setAddon(addedAddon);
        EditPanelManager.setType('addon');

        EditPanelManager.showEditPanel();
      }
    }
  }
}


class AllAddonListItem extends Component {
    render() {
        const {connectDragPreview, connectDragSource, addon} = this.props;
        return(connectDragPreview(
            <span>
                  {connectDragSource(
                  <span>
                    <img src={addon.icon} alt={addon.title} />
                    <span>{addon.title}</span>
                  </span>
                  )}
            </span>
        ))
    }
}

var DragSourceDecorator = DragSource(ItemTypes.ADDON, addonSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);
const mapStateToProps = ( state ) => {
  return {
    state: state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    onSettingsClick: (options) => {
      dispatch(saveSetting(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DragSourceDecorator(AllAddonListItem));


// WEBPACK FOOTER //
// ./src/components/AllAddonListItem.js